import React, {useEffect, useState} from "react";
import {doc, getDoc, setDoc} from "firebase/firestore";
import {db} from "../config/firebase/firebase";
import {useAuth} from "../contexts/authContext";
import {Form, Input, Button, Checkbox, message, Row, Col, Card} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export const CustomCvPage = () => {
    const {currentUser} = useAuth();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const userEmail = currentUser.email;
                const docRef = doc(db, `users/${userEmail}/cv.config/2`);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    form.setFieldsValue({
                        first_name: data["first_name"] || "",
                        last_name: data["last_name"] || "",
                        country: data.country || "Ukraine",
                        city: data.city || "Kyiv",
                        managed: data.managed,
                        education: data.education || [],
                        customers: data.customers || [],
                        languages: data.languages || [],
                        contacts: data.contacts || [],
                    });
                }
            } catch (error) {
                message.error("Error loading data");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [form, currentUser]);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const userEmail = currentUser.email;
            const docRef = doc(db, `users/${userEmail}/cv.config/2`);
            await setDoc(docRef, {...values, isActive: true});
            message.success("Data saved successfully!");
        } catch (error) {
            message.error("Error saving data", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <p>Please specify details for AI CV generation:</p>
            <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ managed: false }}>
                <Card title="Name & Location">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="first_name" label="First Name" rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="last_name" label="Last Name" rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="country" label="Country" rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="city" label="City" rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>
                <Card title="Contacts">
                    <Form.List name="contacts">

                        {(fields, {add, remove}) => (
                            <>
                                {fields.map(({key, name}) => (
                                    <Row key={key} gutter={16} align="middle">
                                        <Col span={12}>
                                            <Form.Item name={[name, "name"]} label="Contact Name">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={10}>
                                            <Form.Item name={[name, "value"]} label="Value">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={2}
                                             style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

                                                <Button
                                                    type="text"
                                                    icon={<DeleteOutlined style={{fontSize: "16px", color: "red"}}/>}
                                                    onClick={() => remove(name)}
                                                />

                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => add()}>Add Contact</Button>
                            </>
                        )}
                    </Form.List>
                </Card>

                <Card title="Languages">
                    <Form.List name="languages">
                        {(fields, {add, remove}) => (
                            <>
                                {fields.map(({key, name}) => (
                                    <Row key={key} gutter={16}>
                                        <Col span={12}>
                                            <Form.Item name={[name, "language"]} label="Language">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={10}>
                                            <Form.Item name={[name, "level"]} label="Level">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={2}
                                             style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

                                                <Button
                                                    type="text"
                                                    icon={<DeleteOutlined style={{fontSize: "16px", color: "red"}}/>}
                                                    onClick={() => remove(name)}
                                                />

                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => add()}>Add Language</Button>
                            </>
                        )}
                    </Form.List>
                </Card>

                <Card title="Education">
                    <Form.List name="education" >
                        {(fields, {add, remove}) => (
                            <>
                                {fields.map(({key, name}) => (
                                    <Row key={key} gutter={16}>
                                        <Col span={12}>
                                            <Form.Item name={[name, "institution"]} label="Institution">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={10}>
                                            <Form.Item name={[name, "period"]} label="Period">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={2}
                                             style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

                                                <Button
                                                    type="text"
                                                    icon={<DeleteOutlined style={{fontSize: "16px", color: "red"}}/>}
                                                    onClick={() => remove(name)}
                                                />

                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => add()}>Add Education</Button>
                            </>
                        )}
                    </Form.List>
                </Card>


                <Card title="Experience">
                    <Form.List name="customers">
                        {(fields, {add, remove}) => (
                            <>
                                {fields.map(({key, name}) => (
                                    <Row key={key} gutter={16}>
                                        <Col span={12}>
                                            <Form.Item name={[name, "company"]} label="Company">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={10}>
                                            <Form.Item name={[name, "period"]} label="Period">
                                                <Input/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={2}
                                             style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

                                                <Button
                                                    type="text"
                                                    icon={<DeleteOutlined style={{fontSize: "16px", color: "red"}}/>}
                                                    onClick={() => remove(name)}
                                                />

                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => add()}>Add Customer</Button>
                            </>
                        )}
                    </Form.List>
                </Card>

                <Card>
                    <Form.Item name="managed" valuePropName="checked">
                        <Checkbox>Managed Team</Checkbox>
                    </Form.Item>
                    <p>(add this checkbox in case you have PM or Team Lead
                        experience)</p>
                </Card>

                <Form.Item>
                    <Button style={{marginTop: 16, marginBottom: 35}} type="primary" htmlType="submit"
                            loading={loading}>Save</Button>
                </Form.Item>
            </Form>
        </>
    );
};